import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {LoadingStatus} from "../../common-types/loading-status";
import {LoadingService} from "../../ui-elements/loading/loading.service";
import {Page} from "../../orchestration/page";
import {IdentityModel} from "../../identity/identity.model";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {AnalyticsService} from "../../orchestration/analytics.service";
import {NavigationService} from "../../orchestration/navigation.service";
import {NotificationService} from "../../notification/notification.service";
import {DealModel} from "../../deal/deal.model";
import {CheckboxSpec} from "../../notification/simple-dialog-page/simple-dialog-page.component";
import {EntityData} from "@fedelta-pos/data-client";
import {MessageDetails, MessageLevel} from "../../notification/message/message";
import {LoyaltyCardData} from "../../identity/member-summary-entity.model";
import {DealData, DealResult, DealResultCode} from "../../deal/deal-entity.model";

@Component({
    selector: "woa-loyalty-cards-page",
    templateUrl: "./loyalty-cards-page.component.html",
    providers: [{provide: Page, useExisting: LoyaltyCardsPageComponent}]
})
export class LoyaltyCardsPageComponent extends Page implements OnInit {
    public static readonly ENABLE_TICKETS: boolean = false;

    public LoadingStatus = LoadingStatus;
    public status: LoadingStatus = LoadingStatus.LOADING;
    public tickets: DealData[] = [];
    public loyaltyCards: LoyaltyCardData[] = [];

    constructor(private orderingContextModel: OrderingContextModel,
                private identityModel: IdentityModel,
                private dealModel: DealModel,
                private loadingService: LoadingService,
                private changeDetectorRef: ChangeDetectorRef,
                private navigationService: NavigationService,
                private analyticsService: AnalyticsService,
                private notificationService: NotificationService) {
        super();
    }

    get contentText(): string {
        return this.showCards || this.status !== LoadingStatus.LOADED ? undefined : "woa.message.loyalty-cards.noCards";
    }

    get showCards(): boolean {
        return this.status === LoadingStatus.LOADED && !this.identityModel.isGuestUser && !!this.identityModel.currentMember &&
            (!!this.tickets.length || !!this.loyaltyCards.length);
    }

    ngOnInit(): void {
        this.status = LoadingStatus.LOADING;
        this.loadMemberSummary();
    }

    loadMemberSummary(): void {
        // noinspection JSIgnoredPromiseFromCall
        this.loadingService.performWithSpinner(async () => {
            try {
                await this.identityModel.loadMemberSummary();
                this.status = LoadingStatus.LOADED;
            } catch (error) {
                this.status = LoadingStatus.FAILED;
            }
            this.tickets = LoyaltyCardsPageComponent.ENABLE_TICKETS ? this.identityModel.tickets : [];
            this.loyaltyCards = this.identityModel.loyaltyCards;
            this.changeDetectorRef.detectChanges();
        });
    }

    async profile(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("profile");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-profile-edit-page");
    }

    async redeemCard(card: LoyaltyCardData): Promise<any> {
        const applyDeal: CheckboxSpec = {
            label: "woa.message.loyalty-cards.autoApplyDeal",
            name: "applyDeal",
            checked: true
        };

        if (await this.notificationService.displayConfirmation("woa.heading.loyalty-cards.confirmRedeemLoyaltyCard", undefined,
            "woa.message.loyalty-cards.confirmRedeemLoyaltyCard",
            "woa.button.common.noThanks", "woa.button.loyalty-cards.confirmRedeem", false,
            {points: card.pointsRequiredToRedeem}, false,
            [applyDeal])) {
            const redemptionResult: any = await this.loadingService.performWithSpinner(async () => await this.dealModel.redeemLoyaltyCard(card));
            this.loadMemberSummary();
            if (redemptionResult != undefined) {
                if (applyDeal.checked) {
                    const deal: DealData = <DealData>EntityData.create(DealData).assign(redemptionResult);
                    if (!deal.id) {
                        // noinspection ES6MissingAwait
                        this.notificationService.displayAlert(null, "woa.message.loyalty-cards.redeemedDealNotAvailable");
                        return;
                    }

                    const result: DealResult = await this.dealModel.orderDeal(deal);
                    if (result.resultCode === DealResultCode.UNAVAILABLE) {
                        await this.notificationService.displayAlert(null, result.msg);
                    } else if (result.resultCode === DealResultCode.IMMEDIATE || result.resultCode === DealResultCode.DEFERRED) {
                        return this.navigationService.dismissPage(this);
                    }
                } else {
                    this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, "woa.message.loyalty-cards.dealRedeemed"));
                    return this.navigationService.dismissPage(this);
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/loyalty-card/loyalty-cards-page/loyalty-cards-page.component.ts